import { render, staticRenderFns } from "./ComplaintSectorUpdate.vue?vue&type=template&id=0e262234&"
import script from "./ComplaintSectorUpdate.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports